import { createRoot } from "react-dom/client";
import { MainView } from "../components/MainView/main-view";
import "bootstrap/dist/css/bootstrap.min.css";

// Import statement to indicate that you need to bundle "./index.scss"

import "./index.scss";

// Main component (will eventually use all the others)
const MyFlixApplication = () => {
  return (
    <div className="my-flix">
      <MainView />
    </div>
  );
};

//Finds the root of your app
const container = document.querySelector("#root");
const root = createRoot(container);

//Tells react to render your app in the root DOM element

root.render(<MyFlixApplication />);
